import React, { useEffect, useState } from "react";
import { getSmartQuestionaireList, deleteSmartQuestionaire, getNormalQuestionaireFormList, sendSmartQuestionaire, deleteNormalQuestionaireForm } from "../../../../services/CommonService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "../SmartQuestionaire.css";
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import DeleteSmartQuestionaireSleeve from './deleteSmartQuestionaireSleeve';

function ManageSmartQuestionaire() {
  const [loading, setLoading] = useState(false);
  const [questionaires, setQuestionaires] = useState([]);
  const [normalForms, setNormalForms] = useState([]);
  const [deleteModal, setDeleteModal] = useState({ show: false, id: null, name: '', uuid: null });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10); // Items per page
  const [totalItems, setTotalItems] = useState(0);
  const [activeTab, setActiveTab] = useState('normal'); // 'normal' or 'smart'
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab === 'smart') {
      fetchList(currentPage);
    } else {
      fetchNormalForms();
    }
  }, [currentPage, activeTab]);

  const fetchList = (page = 1) => {
    setLoading(true);
    getSmartQuestionaireList({ page, limit: pageSize })
      .then((res) => {
        setQuestionaires(res.data.data || []);
        setTotalItems(res.data.total || 0); // API should return total count
        setLoading(false);
      })
      .catch(() => {
        setQuestionaires([]);
        setTotalItems(0);
        setLoading(false);
      });
  };

  const fetchNormalForms = () => {
    setLoading(true);
    getNormalQuestionaireFormList()
      .then((res) => {
        setNormalForms(res.data.data || []);
        setLoading(false);
      })
      .catch(() => {
        setNormalForms([]);
        setLoading(false);
      });
  };

  const handleDelete = (item) => {
    setDeleteModal({ show: true, id: item.sleeve_id, name: item.sleeve_name, uuid: item.sleeve_uuid });
  };

  const confirmDelete = () => {
    if (!deleteModal.uuid) return;
    setLoading(true);
    deleteSmartQuestionaire({ sleeve_uuid: deleteModal.uuid })
      .then((res) => {
        toast.success(res.data.message || "Deleted successfully");
        setDeleteModal({ show: false, id: null, name: '', uuid: null });
        setLoading(false);
        fetchList();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Delete failed");
        setLoading(false);
      });
  };

  const handleNavigateToDetail = (sleeve_uuid, status) => {
    if (status === 1) {
      navigate(`/client-portal/smart-questionnaire/${sleeve_uuid}/step/2`);
    } else {
      navigate(`/client-portal/smart-questionnaire/manage/${sleeve_uuid}`);
    }
  };

  const handleDeleteNormalForm = async (form) => {
    try {
      const response = await deleteNormalQuestionaireForm({ form_uuid: form.form_uuid });
      if (!response.data.message) {
        setNormalForms(prevForms => [...prevForms, form]);
        toast.error(response.data.message || "Failed to delete form");
      } else {
        toast.success("Form deleted successfully!");
        fetchNormalForms();
      }
    } catch (error) {
      setNormalForms(prevForms => [...prevForms, form]);
      console.error("Error deleting form:", error);
      toast.error(error.response?.data?.message || error.message || "Error deleting form");
    }
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}

      <div className="section-bg-color" style={{ minHeight: 'calc(100vh - 54.5px)' }}>
        <div className="container py-4">
          <div className="d-flex align-items-center justify-content-between mb-4 manage-sq-detail" >
            {/* Tabs */}
            <div className="">
              <ul className="nav nav-tabs" style={{ borderBottom: '2px solid #dee2e6' }}>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'normal' ? 'active' : ''}`}
                    onClick={() => setActiveTab('normal')}
                    style={{
                      backgroundColor: activeTab === 'normal' ? '#fff' : 'transparent',
                      color: activeTab === 'normal' ? '#007bff' : '#fff',
                      border: activeTab === 'normal' ? '1px solid #dee2e6' : '1px solid transparent',
                      borderBottom: activeTab === 'normal' ? '1px solid #fff' : '1px solid #dee2e6',
                      marginBottom: '-1px',
                      fontWeight: '500'
                    }}
                  >
                    Normal Questionnaire
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'smart' ? 'active' : ''}`}
                    onClick={() => setActiveTab('smart')}
                    style={{
                      backgroundColor: activeTab === 'smart' ? '#fff' : 'transparent',
                      color: activeTab === 'smart' ? '#007bff' : '#fff',
                      border: activeTab === 'smart' ? '1px solid #dee2e6' : '1px solid transparent',
                      borderBottom: activeTab === 'smart' ? '1px solid #fff' : '1px solid #dee2e6',
                      marginBottom: '-1px',
                      fontWeight: '500'
                    }}
                  >
                    Smart Questionnaire
                  </button>
                </li>
              </ul>
            </div>
            <button
              className="btn btn-light"
              onClick={() => navigate('/client-portal')}
              style={{ display: 'inline-flex', alignItems: 'center' }}
            >
              <i className="bi bi-arrow-left me-2"></i> Back
            </button>
          </div>


          {/* Tab Content */}
          {activeTab === 'normal' ? (
            // Normal Questionnaire Tab Content
            <div className="sq-card p-0 table-responsive">
              <table className="sq-table w-100">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Created</th>
                    <th className="table-header-center">Fill Form</th>
                    <th className="table-header-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {normalForms.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">No data found.</td>
                    </tr>
                  ) : (
                    normalForms.map((form, idx) => (
                      <tr
                        key={form.form_id}
                        style={idx !== normalForms.length - 1 ? { borderBottom: '1px solid #dee2e6' } : {}}
                      >
                        <td>{idx + 1}</td>
                        <td>{form.form_name}</td>
                        <td>{form.created_at ? new Date(form.created_at).toLocaleDateString() : '-'}</td>
                        <td className="table-header-center">
                          <button
                            className="btn btn-success btn-sm"
                            onClick={() => navigate(`/client-portal/normal-questionnaire/submit/${form.form_uuid}`)}
                            style={{ fontWeight: 500, minWidth: '120px' }}
                          >
                            {/* <i className="bi bi-pencil-square me-1"></i> */}
                            Fill Form
                          </button>
                        </td>
                        <td className="table-header-center">
                          <div className="d-flex justify-content-center gap-2">
                            <button
                              className="btn btn-sm btn-primary rounded-circle"
                              onClick={() => navigate(`/client-portal/normal-questionnaire/manage/${form.form_uuid}`)}
                              data-toggle="tooltip"
                              data-placement="top"
                              title="View"
                              style={{ width: '32px', height: '32px', padding: '0', fontWeight: 500 }}
                            >
                              <i className="bi bi-eye"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-danger rounded-circle"
                              onClick={() => handleDeleteNormalForm(form)}
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Delete"
                              style={{ width: '32px', height: '32px', padding: '0', fontWeight: 500 }}
                            >
                              <i className="bi bi-trash"></i>
                            </button>

                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            // Smart Questionnaire Tab Content
            <>
              <div className="sq-card p-0 table-responsive">
                <table className="sq-table w-100">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Created</th>
                      <th>Due Date</th>
                      <th>Recipients</th>
                      <th>Status</th>
                      <th className="table-header-center">Manage</th>
                      <th className="table-header-center"><i className="bi bi-three-dots-vertical" /></th>
                    </tr>
                  </thead>
                  <tbody>
                    {questionaires.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center">No data found.</td>
                      </tr>
                    ) : (
                      questionaires.map((q, idx) => {
                        const menu = (
                          <Menu
                            className="custom-rc-dropdown-menu"
                            onClick={({ key }) => {
                              if (key === 'delete') handleDelete(q);
                            }}
                          >
                            <MenuItem key="delete" className="custom-rc-dropdown-item custom-rc-dropdown-delete">
                              <i className="bi bi-trash me-1"></i>Delete
                            </MenuItem>
                          </Menu>
                        );
                        return (
                          <tr
                            key={q.sleeve_id}
                            style={idx !== questionaires.length - 1 ? { borderBottom: '1px solid #dee2e6' } : {}}
                          >
                            <td>{idx + 1}</td>
                            <td>{q.sleeve_name}</td>
                            <td>{q.created_at ? new Date(q.created_at).toLocaleDateString() : '-'}</td>
                            <td>{q.due_date ? new Date(q.due_date).toLocaleDateString() : '-'}</td>
                            <td>
                              {q.recipients && q.recipients.length > 0 ? (
                                <span className="sq-badge">
                                  {q.recipients.length === 1 ? (
                                    <span className="bi bi-person" style={{ fontSize: 16, marginRight: 4 }}></span>
                                  ) : (
                                    <span className="bi bi-people" style={{ fontSize: 16, marginRight: 4 }}></span>
                                  )}
                                  {q.recipients.length} recipient{q.recipients.length > 1 ? 's' : ''}
                                </span>
                              ) : '-'}
                            </td>
                            <td>
                              {q.status === 1 && (
                                <span className="badge bg-secondary">Draft</span>
                              )}
                              {q.status === 2 && (
                                <span className="badge bg-warning text-dark">In Progress</span>
                              )}
                              {q.status === 3 && (
                                <span className="badge bg-success">Complete</span>
                              )}
                            </td>
                            <td className="table-header-center">
                              <button
                                className="btn btn-primary btn-sm px-3"
                                onClick={() => handleNavigateToDetail(q.sleeve_uuid, q.status)}
                                style={{ fontWeight: 500 }}
                              >
                                Manage
                              </button>
                            </td>
                            <td className="table-header-center">
                              <Dropdown
                                trigger={["click"]}
                                overlay={menu}
                                animation="slide-up"
                                placement="bottomRight"
                              >
                                <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', height: '32px' }}>
                                  <i className="bi bi-three-dots-vertical" style={{ fontSize: 20 }}></i>
                                </span>
                              </Dropdown>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
              {/* <div className="d-flex justify-content-end mt-3">
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>&laquo;</button>
                    </li>
                    {Array.from({ length: Math.ceil(totalItems / pageSize) }, (_, i) => (
                      <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === Math.ceil(totalItems / pageSize) || totalItems === 0 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === Math.ceil(totalItems / pageSize) || totalItems === 0}>&raquo;</button>
                    </li>
                  </ul>
                </nav>
              </div> */}
            </>
          )}
        </div>
        <DeleteSmartQuestionaireSleeve
          show={deleteModal.show}
          name={deleteModal.name}
          deleting={loading}
          onCancel={() => setDeleteModal({ show: false, id: null, name: '', uuid: null })}
          onDelete={confirmDelete}
        />
      </div>
    </>
  );
}

export default ManageSmartQuestionaire; 